import React from 'react'
import Container from '@/components/Container/Container'
import styles from './Content.module.scss'
import VARIABLES from '@/styles/config/_variables.module.scss'
import DATA_PRIVACY_POLICY from '@/data/privacy-policy'
import DATA_TERMS_AND_CONDITIONS from '@/data/terms-and-conditions'
import { ETypography } from '@/interfaces'
import cx from 'classnames'

export enum EContentType {
  privacyPolicy = 'privacyPolicy',
  termsAndCondition = 'termsAndCondition',
}

const DATA = {
  [EContentType.privacyPolicy]: DATA_PRIVACY_POLICY,
  [EContentType.termsAndCondition]: DATA_TERMS_AND_CONDITIONS,
}

type Props = {
  type: EContentType
}

const SectionContent = ({ type }: Props) => {
  const data = DATA[type]
  return (
    <section className={styles.section}>
      <Container small styleInline={{ zIndex: VARIABLES.zIndexModalSup }}>
        <h1 className={cx(styles.title, ETypography.sh1)}>{data.title}</h1>
        {data.texts.map((text, index) => {
          const content = (
            <>
              {text.text}
              {text.hrefText && (
                <>
                  <a
                    className={cx(styles.a)}
                    key={`text-${index}`}
                    target="_blank"
                    rel="noreferrer noopener"
                    href={text.href}
                  >
                    {text.hrefText}
                  </a>
                  {text.endText && text.endText}
                </>
              )}
            </>
          )

          if (text.tag === 'h3' || text.tag === 'h4') {
            return (
              <h3 className={cx(styles[`s${text.tag}`], ETypography[`s${text.tag}`])} key={`text-${index}`}>
                {text.text}
              </h3>
            )
          } else if (text.tag === 'li') {
            return (
              <li className={cx(styles.list)} key={`text-${index}`}>
                {content}
              </li>
            )
          }
          return (
            <p key={`text-${index}`} className={cx(styles.paragraph)}>
              {content}
            </p>
          )
        })}
      </Container>
    </section>
  )
}

export default SectionContent
